export default [
  {
    path: '/newCustomers',
    name: 'newCustomers',
    meta: {
      hideTab: true
    },
    component: () => import('@/views/newCustomers/index.vue')
  }
]